import { render } from "./wAuto.vue?vue&type=template&id=264ab3d1"
import script from "./wAuto.vue?vue&type=script&lang=js"
export * from "./wAuto.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__